import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=2bceff96"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=2bceff96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports